import { render, staticRenderFns } from "./GreetingCard.vue?vue&type=template&id=2900b0a2&scoped=true&"
import script from "./GreetingCard.vue?vue&type=script&lang=js&"
export * from "./GreetingCard.vue?vue&type=script&lang=js&"
import style0 from "./GreetingCard.vue?vue&type=style&index=0&id=2900b0a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900b0a2",
  null
  
)

export default component.exports